/**
 * Origem de um lançamento: à mão ou por operação em lote.
 *
 * Espelha `App\Constants\FinancialAdjustmentOriginTypes` no backend — os valores viajam no corpo
 * da busca e na query string da tela, então divergir aqui quebra o filtro em silêncio.
 *
 * ⚠️ Não confundir com o `source` do lançamento (`financial`, `billing`, `financial_solution`…),
 * que diz qual ROTINA o criou. Um estorno de comissão tem `source = 'financial'` e nasce de
 * código, mas fora de uma operação declarada — e aqui ele conta como manual, porque não há lote
 * nenhum a que voltar.
 */
export const ORIGIN_ALL = 'all'
export const ORIGIN_MANUAL = 'manual'
export const ORIGIN_BATCH = 'batch'

export const ORIGIN_OPTIONS = [
  { value: ORIGIN_ALL, label: 'Manual e em lote' },
  { value: ORIGIN_MANUAL, label: 'Somente manual' },
  { value: ORIGIN_BATCH, label: 'Somente em lote' },
]
